export default __webpack_public_path__ + "static/sun-chasers-mobile-e09ee4c8283cc3cbb6e100a81b304049.webp";